import React from 'react';
import { X, ArrowRight } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription, DialogClose } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { getPattern } from '@/data/ekg';
import { EcgTrace } from './EcgTrace';

export const BundleComparison = ({ open, onOpenChange, onSelect }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="ekg-dialog ekg-comparison-dialog [&>button]:hidden" data-testid="ekg-comparison-dialog">
      <div className="flex justify-between gap-3 items-start">
        <div><DialogTitle className="text-lg">RSB oder LSB?</DialogTitle><DialogDescription className="mt-1">V1 und V6 im direkten Vergleich · schematisch</DialogDescription></div>
        <DialogClose asChild><Button size="icon" variant="ghost" data-testid="ekg-comparison-close" aria-label="Vergleich schließen"><X size={20} /></Button></DialogClose>
      </div>
      <div className="ekg-comparison-grid">{['rbbb', 'lbbb'].map(id => {
        const pattern = getPattern(id);
        return <section key={id} data-testid={`ekg-compare-${id}`}>
          <h3 className="font-semibold text-base mb-4">{pattern.title}</h3>
          {pattern.focus.map(({ lead, note }) => <div key={lead} className="ekg-lead mb-3">
            <div className="ekg-lead-heading"><strong>{lead}</strong><span className="text-xs text-muted-foreground">{note}</span></div>
            <EcgTrace pattern={pattern} lead={lead} duration={1} annotated={false} testId={`ekg-comparison-${id}-${lead}`} />
          </div>)}
          <p className="text-sm text-teal-900 font-medium leading-relaxed mb-3" data-testid={`ekg-compare-mnemonic-${id}`}>{pattern.mnemonic}</p>
          <Button variant="outline" className="w-full gap-2" data-testid={`ekg-compare-select-${id}`} onClick={() => { onSelect(id); onOpenChange(false); }}>Befund öffnen<ArrowRight size={16} /></Button>
        </section>;
      })}</div>
      <p className="text-xs text-muted-foreground" data-testid="ekg-comparison-caution">Kompletter Schenkelblock: QRS ≥ 120 ms beim Erwachsenen. Die Form allein reicht nicht; nicht jeder Block hat eine perfekte M-/W-Form.</p>
    </DialogContent>
  </Dialog>
);